'use strict';

//This gives yield and async/await support in ES5 environments
//We shouldn't even need it :/
//postal.xframe uses regeneratorRuntime.mark
//if we customise xframe we can remove it

import postal from "postal";
import "postal.federation";
import "regenerator-runtime";
import "postal.xframe";
import addRequestResponse from "kernel/messagebus/request-response";
//import "postal.request-response";

Promise.defer = function() { //Promise defer shim, saves 5k over using Q.js
	var deferred = {};

	var promise = new Promise(function(resolve, reject) {
		deferred.resolve = resolve;
		deferred.reject = reject;
	});
	deferred.promise = promise;
	return deferred;
};

addRequestResponse(postal);

var initCalled = false;

//if (federation && xframe && requestresponse && 1===0) {
//	console.log('This is to stop shaking postal out');
//}
/**
 * @module messagebus/MessageBus
 * @memberof kernel
 * @description  Handles PostalJS Bus Service initialisation
 */
//define(function(require){

	/**
	 * @function init
	 * @instance
	 * @description  Creates PostalJS instance and configures it with Kernel Config
	 * @param config {object} configuration payload - TODO {@type config}
	 * @returns void
	 */
	function init(config){
		if(arguments.length === 0 ){
			throw new Error('Message Bus Configuration Payload cannot be empty, malformed or undefined');
		}else {
			// Every instance of Postal needs an Id set in order to communicate with other Postal instances.
			postal.instanceId("Kernel");

			var allowedDomains = [];

			for(var i=0; i<config.allowedDomains.length; i++){
				var domain = getHostDomainFromString(config.allowedDomains[i]);
				allowedDomains.push(domain);
			}

			// Set up allowed domains for message bus communication
			postal.fedx.transports.xframe.configure({
			 	allowedOrigins : allowedDomains,
			 	defaultOriginUrl : config.defaultOrigin,
				safeSerialize:true
			});

			// Set up allowed message channels with filters
			postal.fedx.addFilter(config.channels);

			// We need to tell postal how to get a deferred instance
			postal.configuration.promise.createDeferred = function() {
				return Promise.defer();
			};
			// We need to tell postal how to get a "public-facing"/safe promise instance
			postal.configuration.promise.getPromise = function(dfd) {
				return dfd.promise;
			};

			// Debug logs for Bus Messaging
			//No point in having a wiretap to an empty function, that tap will keep happening.
			// Needless performance hit, even if negligible.
			//postal.addWireTap( function( data, envelope ) {
				//console.log("[PF BUS]",envelope);
			//});

			// Postal instance is ready to transmit/receive
			postal.fedx.signalReady();
			initCalled = true;
			return true;
		}

	}

	function getBusStatus() {
		if (initCalled) {
			return "INITIALISED";
		} else {
			return "UNINITIALISED";
		}
	}

	/**
	 * @function getHostDomainFromString
	 * @description helper function for stripping the host domain
	 * @param url
	 * @returns {XML|string}
	 */
	function getHostDomainFromString(url){
    	var tempurl =  url.replace(/^((\w+:)?\/\/[^\/]+\/?).*$/,'$1');
		return tempurl.replace(/\/$/, "");
	}

	/**
	 * @function publish
	 * @instance
	 * @description  Publishes a message on a specified channel,topic with optional data
	 * @param payload {object} - Message Payload (channel,topic,data)
	 * @example
	 * bus.publish({channel: "ClientService",topic: "ErrorHandler",data:{}});
	 * @returns void
	 */
	function publish(payload){
		postal.publish(payload);
	}

	/**
	 * @function subscribe
	 * @instance
	 * @description  Subscribes to a Bus message with a specified channel and topic
	 * @param payload {object} - Message Payload (channel,topic,callback)
	 * @example
	 * bus.subscribe({channel: "ClientService",topic: "ErrorHandler",callback:function(data,envelope){}});
	 * @returns {Function} Reference to the subscribed object
	 */
	function subscribe(payload){
		return postal.subscribe(payload);
	}

	/**
	 * @function request
	 * @description initiates a request response message
	 * @param {Object} payload
	 * @param {Function} success callback function
	 * @param {Function} error callback function
	 * @example
	 * bus.subscribe({
			channel:"ClientService",
			topic:"MessageBox.Close",
			callback:function(data,envelope){
				// When message is received you can reply on the same channel & topic using envelope.reply api
				// The first parameter is for error callback, second is for success callback
				envelope.reply(null,data);
			}
		})

		// Test request response API of message bus
		bus.request({
				channel:"ClientService",
				topic: "MessageBox.Close",
				data: {},
				timeout: 2000 // if you require a response within a specified elapsed time
			},
	 		// Success callback
			function(data) {
				//console.log("Successful response:",data);
			},
	 		// Fail callback
			function(err) {
				//console.log("Error response: " + err);
			}
		);
	 */
	function request(payload,success,error){
		var chn1 = postal.channel(payload.channel);
		return chn1.request(payload).then(success,error);
	}

	/**
	 * @function unsubscribe
	 * @instance
	 * @description  Unsubscribes a previous messagebus subscriber
	 * @param subscriber {object} a local reference to the subscription object
	 * @example
	 * var subscriber = bus.subscribe({channel:"Kernel",topic:"LoadProgress",callback:foo});
	 * bus.unsubscribe(subscriber);
	 * @returns void
	 */
	function unsubscribe(subscriber){
		postal.unsubscribe(subscriber);
	}

	var mainAPI = Object.freeze({
		publish:publish,
		subscribe:subscribe,
		unsubscribe:unsubscribe,
		request:request,
		getBusStatus:getBusStatus
	});

	export { init };
	export { publish };
	export { subscribe };
	export { unsubscribe };
	export { request };
	export { getBusStatus };

	export default mainAPI; //For regular use
//});